import React, { FunctionComponent } from "react";

import NavBarKebabMenu from "../nav_bar_kebab_menu";
import NavBarManageUsersIcon from "../nav_bar_manage_users_icon";
import NavBarRedesignIconButton from "./nav_bar_redesign_icon_button";
import NavBarRedesignOverflowMenu from "./nav_bar_redesign_overflow_menu";
import PageNames from "../../../models/domain/enums/page_names";
import { NavRouteContext } from "./nav_bar_redesign_route";
import { RedesignNavItem } from "./nav_bar_redesign_options";

export type Props = {
  icons: RedesignNavItem[]
  overflow: RedesignNavItem[]
  pageName: PageNames
  routeContext: NavRouteContext
};

// Right-side cluster per Figma: Integrations + Operations icon buttons, the existing manage-users
// icon, the "..." overflow, and the existing kebab/avatar user menu (Profile / Support Center /
// Logout). NavBarManageUsersIcon and NavBarKebabMenu are reused and gate themselves; the
// manage-users icon takes the `redesign` glyph and selection-line treatment so it matches the rest of
// this row.
const NavBarRedesignActions: FunctionComponent<Props> = ({ icons, overflow, pageName, routeContext }) => {
  return <div className="NavBarRedesign-actions">
    <div className="NavBarRedesign-iconGroup">
      {icons.map((item) => <NavBarRedesignIconButton
        key={item.key}
        item={item}
        active={item.base.pageNames.has(pageName)}
        routeContext={routeContext}
      />)}
      <NavBarManageUsersIcon redesign/>
      <NavBarRedesignOverflowMenu items={overflow} pageName={pageName} routeContext={routeContext}/>
    </div>
    <NavBarKebabMenu/>
  </div>;
};

export default NavBarRedesignActions;
